import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { RADIUS } from 'src/theme/ui-tokens';

import { PlatformIcon } from './home-platform-icon';
import { CHANNELS, COVERAGE_FACTS, CHANNEL_HIGHLIGHTS } from '../constants/home-copy';
import { CM, SECTION_PX, SECTION_PY, PUBLIC_TEXT, PUBLIC_MAX_WIDTH } from '../constants/home-theme';

// ----------------------------------------------------------------------

/**
 * 어디서 모으나 — 채널 열넷과, 모으는 방식이 마케터에게 주는 것 셋.
 * ⛔ 근거를 못 대는 수집량·「AI 알고리즘」 같은 말을 적지 않는다 — 채널과 판별 방식만 적는다.
 * ⛔ 플랜별 채널 차이(@cosme·LIPS)는 여기 적지 않는다 — 요금 비교표만 말한다.
 */
export function HomeChannelsSection() {
  return (
    <Box component="section" data-section-id="channels" sx={{ px: SECTION_PX, py: SECTION_PY }}>
      <Box sx={{ maxWidth: PUBLIC_MAX_WIDTH, mx: 'auto' }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          <Typography sx={{ ...PUBLIC_TEXT.eyebrow, color: CM.primary, mb: 1.5 }}>수집 채널</Typography>
          <Typography component="h2" sx={{ ...PUBLIC_TEXT.title, color: CM.textDark, mb: 2 }}>
            국내외 {CHANNELS.length}개 채널에서 모읍니다
          </Typography>
          <Typography sx={{ ...PUBLIC_TEXT.lead, color: CM.textMuted, maxWidth: 620, mx: 'auto' }}>
            SNS부터 {'국내\u00A0커뮤니티'}, 일본 @cosme까지
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, mb: 2 }}>
          {CHANNELS.map((channel) => (
            <Stack
              key={channel.platformId}
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ px: 2, py: 1, borderRadius: RADIUS.pill, border: `1px solid ${CM.border}`, bgcolor: '#fff' }}
            >
              <PlatformIcon platformId={channel.platformId} size={18} />
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: CM.textBody }}>{channel.name}</Typography>
            </Stack>
          ))}
        </Box>

        {/* 강조 칩 — 채널 칩과 같은 꼴에 하늘색 면·테두리로 갈라 세운다 */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, mb: { xs: 4, md: 6 } }}>
          {CHANNEL_HIGHLIGHTS.map((item) => (
            <Stack
              key={item.label}
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ px: 2, py: 1, borderRadius: RADIUS.pill, border: `1px solid ${CM.borderLight}`, bgcolor: CM.alpha(0.08) }}
            >
              <PlatformIcon platformId={item.platformId} size={18} />
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: CM.primaryDark }}>{item.label}</Typography>
            </Stack>
          ))}
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
          {COVERAGE_FACTS.map((fact) => (
            <Box key={fact.title} sx={{ p: 3, borderRadius: RADIUS.lg, bgcolor: CM.bgSection, border: `1px solid ${CM.border}` }}>
              <Typography component="h3" sx={{ fontSize: 17, fontWeight: 600, color: CM.textDark, mb: 1 }}>{fact.title}</Typography>
              <Typography sx={{ ...PUBLIC_TEXT.body, color: CM.textMuted }}>{fact.desc}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
